var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirconditioner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6967 39.9088V31.6277L12.2492 38.0131L9.47179 35.2195L18.6967 25.9407V21.9498H14.729L5.50409 31.2286L2.7267 28.435L9.07502 21.9498H0.842041V17.9589H9.07502L2.7267 11.4738L5.50409 8.68015L14.729 17.9589H18.6967V13.9681L9.47179 4.68928L12.2492 1.89567L18.6967 8.28107V0H22.6644V8.28107L29.1119 1.89567L31.8893 4.68928L22.6644 13.9681V17.9589H26.6321L35.857 8.68015L38.6344 11.4738L32.2861 17.9589H40.519V21.9498H32.2861L38.6344 28.435L35.857 31.2286L26.6321 21.9498H22.6644V25.9407L31.8893 35.2195L29.1119 38.0131L22.6644 31.6277V39.9088H18.6967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirconditioner);
export default __webpack_public_path__ + "static/media/airconditioner.115e30511a92441485e009ec2f5195e3.svg";
export { ForwardRef as ReactComponent };